module.exports = __webpack_public_path__ + "static/img/img.091575da.jpg";